export default "__VITE_ASSET__r6Nx3_cO__"